import type { PropsWithChildren, ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { Platform, ScrollView, View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Spacer } from '@/src/elements/spacer/Spacer'
import { GradientTypography } from '@/src/elements/text/gradient'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'

import type { REWARD_CITATION_TYPE } from '../../../models/rewardCitationType.enum'
import { PrayRewardCitation } from '../../components/PrayRewardCitation/PrayRewardCitation'

export type TPrayRewardPageProps = {
  onContinue: VoidFunction
  isLoading?: boolean
  successDetails?: ReactNode
  testID?: string
  rewardType?: REWARD_CITATION_TYPE
}

export const PrayRewardSharedScreen = ({
  children,
  testID,
  successDetails,
  onContinue,
  isLoading,
  rewardType,
}: PropsWithChildren<TPrayRewardPageProps>): ReactNode => (
  <ScrollView
    testID={testID}
    className="native:flex-1 web:max-h-screen"
    contentContainerStyle={{ alignItems: 'center', flexGrow: 1, ...(Platform.OS === 'web' && { flex: 1 }) }}
  >
    <View className="flex-column flex w-full max-w-[500px] web:flex-1 native:grow justify-start gap-6 px-4 pt-10">
      <View className="gap-2 px-4">
        <GradientTypography className="text-2xl font-black sm:text-3xl" colors="primary">
          <FormattedMessage id="community.description.prayer.success" />
        </GradientTypography>
        {successDetails}
      </View>
      <PrayRewardCitation rewardType={rewardType} />
      {children && (
        <>
          <Spacer y={5} />
          {children}
        </>
      )}
      <View className="my-6 flex w-full flex-row items-center justify-center">
        <Button
          onPress={onContinue}
          testID={TEST_ID.REWARD.CONTINUE}
          variant="light"
          colors="primary"
          endIcon={ICON.CHEVRON_RIGHT}
          isLoading={isLoading}
        >
          <FormattedMessage id="word.continue" />
        </Button>
      </View>
    </View>
  </ScrollView>
)
